import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import url from '../url';
var PARAMS_TO_PROPAGATE = ['cloudInstance', 'environment', 'server'];

var enhancer = function enhancer(customHistory) {
  //   const customHistory = createBrowserHistory();
  var nativePush = customHistory.push;

  customHistory.push = function (path, state) {
    return nativePush(propagateMicroserviceQueryParameters(path), state);
  };

  var nativeReplace = customHistory.replace;

  customHistory.replace = function (path, state) {
    return nativeReplace(propagateMicroserviceQueryParameters(path), state);
  };

  var propagateMicroserviceQueryParameters = function propagateMicroserviceQueryParameters(path) {
    var crtSearch = customHistory.location.search;
    var crtSearchParams = url.getSearchParams(crtSearch);
    var hashIndex = path.indexOf('#');
    var hashPart = hashIndex > 0 ? path.substring(hashIndex) : '';
    var nextSearchParams = url.extractSearchParams(hashIndex > 0 ? path.substring(0, hashIndex) : path);
    var paramsToAdd = {};

    if (typeof path === 'string') {
      PARAMS_TO_PROPAGATE.map(function (param) {
        if (!nextSearchParams[param] && crtSearchParams[param]) paramsToAdd[param] = crtSearchParams[param];
      });
      path = url.parseUrl(path).url + '?' + url.stringifySearchParams(_objectSpread({}, paramsToAdd, nextSearchParams)) + hashPart;
    }

    return path;
  };

  return customHistory;
};

export default enhancer;